import type { ChannelEntity } from '@/features/channel/domain/entities/ChannelEntity'

export class BranchTagsFilterEntity {
  id?: number
  isActive?: boolean
  channels?: ChannelEntity[]
  name?: string
  sortField?: string
  sortDescending?: boolean
  page?: number
  limit?: number
  branchTagIds?: number[]
}
